import { useState } from "react";

export default function useEditor<T extends object>(entity: T) {
    const [reader, setReader] = useState<T>(entity);

    function reset() {
        setReader(entity);
    }

    function writer(key) {
        return function onChange(value) {
            setReader((reader as unknown as { change: (change: Record<string, unknown>) => T }).change({ [key]: value }));
        };
    }

    return {
        reader,
        reset,
        writer,
    };
}
